export default {
  register: Alpine => {
    // Alpine stores
    const alpineStores = import.meta.glob('./stores/*.ts', {eager: true, import: 'default'})

    for (const path in alpineStores) {
      if (path) {
        const store = alpineStores[path] as {name: string; store: () => unknown}
        Alpine.store(store.name, store.store())
      }
    }

    // Alpine components
    const alpineComponents = import.meta.glob('./components/**/*.ts', {eager: true, import: 'default'})
    for (const path in alpineComponents) {
      if (path) {
        const component = alpineComponents[path] as {name: string; component: () => unknown}
        Alpine.data(component.name, component.component)
      }
    }
  }
}
